import React, { useState } from 'react';
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';
import Visibility from '@material-ui/icons/Visibility';
import Edit from '@material-ui/icons/Edit';
import { ReactComponent as PersonRemoved } from 'assets/icons/PersonRemoved.svg';
import Link from 'react-router-dom/Link';
import DialogDisableUser from './Dialogs/DialogDisableUser';
import { useTranslation } from 'react-i18next';
import { useStyles } from 'components/layout/CommonStyles';
import { GetGeneralPermissionForAction } from 'utils/permissions/GetGeneralPermissionForAction';
import { Screen, Allow } from 'global/constants';
import { screenStyles } from './Styles';

const UsersTableActions = props => {
    const styles = screenStyles();
    const classes = useStyles();
    const [t] = useTranslation();
    const { item } = props;
    const [open, setOpen] = useState(false);

    return (
        <React.Fragment>
            <Link to={`/Admin/Users/View/${item.id}`}>
                <Tooltip
                    title={t('GENERAL.view')}
                    aria-label="details"
                    placement="top"
                >
                    <IconButton className={classes.iconsTableActions}>
                        <Visibility />
                    </IconButton>
                </Tooltip>
            </Link>
            {GetGeneralPermissionForAction(Screen.ADMIN_USERS, Allow.EDIT) && (
                <Link to={`/Admin/Users/Edit/${item.id}`}>
                    <Tooltip
                        title={t('GENERAL.edit')}
                        aria-label="details"
                        placement="top"
                    >
                        <IconButton className={classes.iconsTableActions}>
                            <Edit />
                        </IconButton>
                    </Tooltip>
                </Link>
            )}
            {GetGeneralPermissionForAction(Screen.ADMIN_USERS, Allow.EDIT) && (
                <Tooltip
                    title={t('GENERAL.disableUser')}
                    aria-label="details"
                    placement="top"
                >
                    <IconButton
                        disabled={!item.enabled}
                        onClick={() => setOpen(true)}
                        className={classes.iconsTableActions}
                    >
                        <PersonRemoved />
                    </IconButton>
                </Tooltip>
            )}
            {open ? (
                <DialogDisableUser
                    open={open}
                    setOpen={setOpen}
                    viewValues={item}
                />
            ) : null}
        </React.Fragment>
    );
};

export default UsersTableActions;
